import { render } from "./ProductsViewed.vue?vue&type=template&id=cc51194a&scoped=true"
import script from "./ProductsViewed.vue?vue&type=script&lang=js"
export * from "./ProductsViewed.vue?vue&type=script&lang=js"

import "./ProductsViewed.vue?vue&type=style&index=0&id=cc51194a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cc51194a"]])

export default __exports__